var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgDelayIcon = function SvgDelayIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4a8 8 0 0 0-8 8h1c0-1.819.809-3.449 2.088-4.549l3.052 3.815a2 2 0 1 0 1.126-1.126L3.5 7.127A6 6 0 0 1 13.001 12h3a8 8 0 0 0-8-8z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDelayIcon);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;